export const TERMS_URL =
  'https://goodstack.org/legal/applicant-validation-terms'
